<template>
    <div class="teach">
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Hash Game Detail'"></navTitle>
        <div class="nav">
            <div class="btn" :class="{active : itemIndex == 1}" @click="btnClick(1)">Pengantar Hash</div>
            <div class="btn" :class="{active : itemIndex == 2}" @click="btnClick(2)">Terikat TRON</div>
            <div class="btn" :class="{active : itemIndex == 3}" @click="btnClick(3)">Pertukaran Cepat</div>
        </div>
        <div class="detail">
            <div v-if="itemIndex == 1">
                <div class="title">{{hash_title}}</div>
                <div class="content" id="hash_content" v-html="hash_content"></div>
            </div>
            <div v-if="itemIndex == 2">
                <hashWallet/>
            </div>
            <div v-if="itemIndex == 3">
                <flashExchange/>
            </div>
        </div>
    </div>
</template>

<script>
    import navTitle from "@components/navTitle"
    import flashExchange from "@views/hash/hash-game"
    import hashWallet from "@views/hash/hash-wallet"
    import {getArticleDetails} from "@api/public"

    export default {
        name: "hash-game.vue",
        components: {navTitle, flashExchange, hashWallet},
        data() {
            return {
                itemIndex: 1,
                hash_title: '',
                hash_content: '',
            };
        },
        created() {
            this.getHashIntroduce()
            this.itemIndex = this.getUrlKey('active') === null ? 1 : this.$route.query.active
        },
        methods: {
            getUrlKey(name) {
                return (
                    decodeURIComponent(
                        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                            location.href
                        ) || [, ""])[1].replace(/\+/g, "%20")
                    ) || null
                )
            },
            getHashIntroduce() {
                getArticleDetails(56).then(res => {
                    this.hash_title = res.data.title
                    this.hash_content = res.data.content
                }).catch(err => {
                    console.log(err)
                })
            },
            btnClick(index) {
                this.itemIndex = index
            },
        }
    }
</script>

<style scoped>
    .teach {
        background: #fff;
        height: 800px;
        overflow-y: scroll;
    }

    .nav {
        color: #333333;
        margin-top: 1rem
    }

    .btn {
        padding: .1rem 2%;
        text-align: center;
        width: 33.333%;
        float: left;
        background: #F8F8FF;
    }

    .active {
        border-bottom: 2px solid #00c3f9 !important;
    }

    .detail {
        clear: both;
    }

    .title {
        text-align: center;
        margin-top: 1rem
    }

    .content {
        padding: 0 .1rem;
    }

</style>